import { createContext, useContext, useState, useCallback } from "react";

const NotifyContext = createContext(() => {});

export function Notifier({ children }) {
  const [msgs, setMsgs] = useState([]);
  const notify = useCallback((text) => {
    if (!text) return;
    const id = Date.now() + Math.random();
    setMsgs((m) => [...m, { id, text }]);
    setTimeout(() => setMsgs((m) => m.filter((x) => x.id !== id)), 4000);
  }, []);
  return (
    <NotifyContext.Provider value={notify}>
      {children}
      <div className="notify-container" aria-live="polite">
        {msgs.map((m) => (
          <div key={m.id} className="toast">
            {m.text}
          </div>
        ))}
      </div>
    </NotifyContext.Provider>
  );
}

export const useNotify = () => useContext(NotifyContext);
